import { render, staticRenderFns } from "./BtnHistory.vue?vue&type=template&id=0cb81c6c"
import script from "./BtnHistory.vue?vue&type=script&lang=js"
export * from "./BtnHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports